<template>
  <form class="p-2" @submit.prevent="handleAddVehicle">
    <modal-container :show="show" @close="onCancel">
      <template slot="header">
        <h4 class="mb-0">{{ $t("add-vehicle") }}</h4>
      </template>

      <template slot="body">
        <div class="form-group">
          <label for="name"> {{ $t("vehicle-name") }}</label>
          <input
            type="text"
            name="name"
            v-model="name"
            class="form-control"
            required
            id="receiver-name"
            :placeholder="$t('enter-vehicle-name')"
            @keypress="isLetter($event)"
          />
        </div>
        <div class="form-group">
          <label for="plateNumber"> {{ $t("plate_number") }}</label>
          <input
            v-model="plateNumber"
            type="text"
            name="plateNumber"
            class="form-control"
            required
            id="plateNumber"
            :placeholder="$t('enter-plate-number')"
          />
        </div>
        <div class="form-group">
          <label for="vehicle"> {{ $t("vehicle-type") }} </label>
          <select
            v-model="type"
            name="vehicle"
            class="form-control"
            required
            id="vehicle"
          >
            <option value="" disabled>{{ $t("select-vehicle") }}</option>
            <option v-for="vehicle in vehicles" :key="vehicle" :value="vehicle">
              {{ vehicle }}
            </option>
          </select>
        </div>
      </template>
      <template slot="footer">
        <div style="display: flex; justify-content: end">
          <button type="submit" class="btn btn-primary text-capitalize">
            {{ $t("add") }}
          </button>
        </div>
      </template>
    </modal-container>
  </form>
</template>

<script>
import ModalContainer from "../../../components/ModalContainer.vue";

export default {
  name: "AddDriverModal",
  components: {
    ModalContainer,
  },
  props: {
    show: Boolean,
    onCancel: Function,
    vehicle: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    // ...mapGetters([]),
    vehicles() {
      return ["Truck", "Car", "Motorcycle"];
    },
  },
  data() {
    return {
      name: this.vehicle?.name || "",
      plateNumber: this.vehicle?.plateNumber || "",
      type: this.vehicle?.type || "",
    };
  },
  methods: {
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[a-zA-Z\s\b]*$/.test(char)) return true;
      else e.preventDefault();
    },
    handleAddVehicle() {
      this.$emit("add-vehicle", {
        name: this.name,
        plateNumber: this.plateNumber,
        type: this.type.toLowerCase(),
      });
      this.onCancel();
    },
  },
  watch: {
    driver: {
      handler(newValues) {
        this.name = newValues.name || "";
        this.plateNumber = newValues.plateNumber || "";
        this.type = newValues.type.toUpperCase() || "";
      },
      deep: true,
    },
  },
};
</script>

<style></style>
